// extracted by mini-css-extract-plugin
export default {"tagsContainer":"tagsOverlay_tagsContainer__h3h8M"};